import { $, $$, reducedMotion } from './env';

/*
 * Carousel nhẹ (thay Swiper): chuyển cảnh mờ dần + vuốt/kéo + tự chạy.
 * Markup:
 *   [data-carousel data-autoplay="5000"]
 *     .carousel__slide (n cái, thường là <a><img></a> do CMS render)
 *     [data-carousel-dots] [data-carousel-prev] [data-carousel-next] [data-carousel-current] [data-carousel-total]
 * Tự dừng khi rê chuột/focus vào, khi tab ẩn, hoặc khi gọi .pause() (màn không hiển thị).
 */
const pad = (n) => String(n).padStart(2, '0');

export function createCarousel(root) {
  const slides = $$('.carousel__slide', root);
  const dotsBox = $('[data-carousel-dots]', root);
  const cur = $('[data-carousel-current]', root);
  const total = $('[data-carousel-total]', root);
  const delay = parseInt(root.dataset.autoplay, 10) || 0;
  let index = 0;
  let timer = 0;
  let paused = true;
  let hold = false;
  const dots = [];

  if (total) total.textContent = pad(slides.length);
  if (slides.length < 2) root.classList.add('is-single');

  slides.forEach((s, i) => {
    s.setAttribute('aria-roledescription', 'slide');
    s.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
    if (dotsBox) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'carousel__dot';
      b.setAttribute('aria-label', `Banner ${i + 1}`);
      b.addEventListener('click', () => go(i));
      dotsBox.appendChild(b);
      dots.push(b);
    }
  });

  function go(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach((s, k) => {
      const on = k === index;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-hidden', String(!on));
      s.tabIndex = on ? 0 : -1;
      // ảnh slide kế tiếp tải trước để lần chuyển sau không bị trắng
      if (k === (index + 1) % slides.length) {
        const img = $('img', s);
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
    });
    dots.forEach((d, k) => {
      d.classList.toggle('is-active', k === index);
      if (k === index) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    if (cur) cur.textContent = pad(index + 1);
    restart();
  }

  function restart() {
    clearTimeout(timer);
    if (!delay || paused || hold || document.hidden || slides.length < 2 || reducedMotion.matches) return;
    timer = setTimeout(() => go(index + 1), delay);
  }

  const prev = $('[data-carousel-prev]', root);
  const next = $('[data-carousel-next]', root);
  if (prev) prev.addEventListener('click', () => go(index - 1));
  if (next) next.addEventListener('click', () => go(index + 1));

  root.addEventListener('mouseenter', () => { hold = true; restart(); });
  root.addEventListener('mouseleave', () => { hold = false; restart(); });
  root.addEventListener('focusin', () => { hold = true; restart(); });
  root.addEventListener('focusout', () => { hold = false; restart(); });
  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') go(index - 1);
    if (e.key === 'ArrowRight') go(index + 1);
  });
  document.addEventListener('visibilitychange', restart);

  // vuốt/kéo ngang: ngưỡng 40px; chặn click mở link nếu vừa kéo
  let x0 = null;
  let dragged = false;
  const viewport = $('.carousel__viewport', root) || root;
  viewport.addEventListener('pointerdown', (e) => {
    x0 = e.clientX;
    dragged = false;
  });
  viewport.addEventListener('pointerup', (e) => {
    if (x0 === null) return;
    const dx = e.clientX - x0;
    x0 = null;
    if (Math.abs(dx) > 40) {
      dragged = true;
      go(index + (dx < 0 ? 1 : -1));
    }
  });
  viewport.addEventListener('click', (e) => {
    if (dragged) {
      e.preventDefault();
      dragged = false;
    }
  }, true);
  viewport.addEventListener('dragstart', (e) => e.preventDefault());

  go(0);
  return {
    play() { paused = false; restart(); },
    pause() { paused = true; restart(); },
  };
}
